import { library } from "@fortawesome/fontawesome-svg-core";
import { fas, faLock } from "@fortawesome/free-solid-svg-icons";
import { faVk, faTelegram } from "@fortawesome/free-brands-svg-icons";
import FontAwesomeIcon from "@/libs/FontAwesomeIcon.vue";

library.add(fas, faLock, faVk, faTelegram);

export { FontAwesomeIcon };
